
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/privacy-policy",
      function () {
        return require("private-next-pages/mahashivratri/privacy-policy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/privacy-policy"])
      });
    }
  